import {useRef} from 'react';

import {financingEndingApi} from '@dms/api/sales';
import {handleApiError} from '@dms/shared';

import {type ApiError, useOnMount} from 'shared/web';

export type FinancingEndingOperationOpenerProps = {
  operationId: string;
  openDetail: (bulkOperationId: string, onCloseComplete: () => void) => void;
  clearOperationId: () => void;
};

// Keyed by the operation id, so each `?operation=` value loads its operation once. The detail opens
// after the load, not in the commit that changes the location. Closing the detail or a failed load
// clears the parameter. A run cancelled by an unmount does nothing.
export function FinancingEndingOperationOpener(props: FinancingEndingOperationOpenerProps) {
  const [getOperation] = financingEndingApi.useLazyGetFinancingEndingBulkOperationQuery();
  const runRef = useRef({isCancelled: false});

  useOnMount(
    () => {
      const run = {isCancelled: false};
      runRef.current = run;

      getOperation({bulkOperationId: props.operationId})
        .unwrap()
        .then(() => {
          if (run.isCancelled) {
            return;
          }

          props.openDetail(props.operationId, () => {
            if (!run.isCancelled) {
              props.clearOperationId();
            }
          });
        })
        .catch((error: ApiError) => {
          if (!run.isCancelled) {
            handleApiError(error);
            props.clearOperationId();
          }
        });
    },
    () => {
      runRef.current.isCancelled = true;
    }
  );

  return null;
}
